export interface NotificationState {
    notificationList: Array<any> | null;
    notificationByFieldList: Array<any> | null;
    notificationById: any,
    notificationTemplateList: Array<any> | null;
    addNotificationResponse: any;
    updateNotificationResponse: any;
    deleteNotificationResponse: any;

}

export const initialState: NotificationState = {
    notificationList: null,
    notificationByFieldList: null,
    notificationById: null,
    notificationTemplateList: null,
    addNotificationResponse: null,
    updateNotificationResponse: null,
    deleteNotificationResponse: null
}
